import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import Time from "react-time-format";
import Switch from "react-switch";
import "./Switch.css";
import _ from "lodash";
class FillDetailRent extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              R_frosth,
              AddProChange,
              R_kateQarz,
              R_zhmarasht,
              R_karton,
              R_darzan,
              R_nrx,
              R_naweSht,
              R_rezha,
              DarzanChange,
              R_CartonChange,
              NrxtofirstInputINRent,
              R_zhmara,
              createNewPage,
              R_date,
              R_mob,
              R_nawe_barez,
              R_zh_barez,
              R_zh_wasl,
              R_zh_wasl_katy,
              R_anotherInputWakil,
              inputtogler,
              R_open,
              getWaslDataBySearchRent,
              R_getkoygahty,
              getProductDataBySearchRent,
              R_wasl,
              R_search_wakil,
              R_search,
              R_del_dis,
              R_togler,
              R_table,
              saveDetail,
              R_joripara,
              R_wargr,
              R_nrx_dolar,
              R_nrx_dinarr,
              R_nrx_dinarr2,
              R_nrx_niwkarton,
              R_nrx_kmtrdadarzan,
              R_rasidKarton,
              R_productBuy,
              R_search_wasl,
              R_save,
              R_qazanj,
              R_kren,
              R_nrxkaton,
              R_CartonDarzanSfr,
              toKoyGshtiSave,
              setSearchEmptyRentWakil,
              setSaletSearchEmty,
              W_wakelakanSearch,
              toanotherInput,
              R_nrxchange,
              R_darzankartontoanotherInput,
              R_DarzanChange,
              WakilNameHandle,
              OnChangeSwitch,
              OnChangeSwitch_IQD,
              R_Nrx_J_T_check,
              R_Nrx_IQD_check,
              R_dataTable,
              R_Dolar2,
              OnChangeSwitch_Mufrad,
              R_Mufrad_check,
              R_Item_check,
              OnChangeSwitch_Item,
              R_dp,
              R_singleSale
            } = value;

            const wakilakan = W_wakelakanSearch.filter((user) => {
              return user.Name.startsWith(R_nawe_barez);
            }).map((item, index) => {
              if (R_frosth == "فرۆشتنی ڕاستەوخۆ") {
                return null;
              } else {
                return (
                  <option key={index} className="fk">
                    {item.Name}
                  </option>
                );
              }
            });
            return (
              <>
                <div style={{ marginTop: "3.5em" }}>
                  <form>
                    <div
                      className="row text-warning font-weight-bold f4 sl-cust"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <div className="col-3 form-inline row sl-flat">
                        <div className="col-4 mt4 sl-f-profit">
                          <h5
                            className="border b--black bg-black text-white p-1"
                            name="qazanj"
                          >
                            {R_search ? ` ${Number(R_qazanj).toFixed(2)}` : ""}
                          </h5>
                          {R_Nrx_J_T_check ? (
                            <h5
                              className="border b--black bg-danger text-white p-1"
                              name="qazanj"
                            >
                              {R_search
                                ? ` ${Number(
                                    (
                                      (Number(R_nrx_dolar) - R_kren) *
                                      R_rezha
                                    ).toFixed(4)
                                  ).toFixed(2)}`
                                : ""}
                            </h5>
                          ) :  <h5
                              className="border b--black bg-danger text-white p-1"
                              name="qazanj"
                            >
                              {R_search
                                ? ` ${Number(
                                    (
                                      (Number(R_Dolar2) - R_kren) *
                                      R_rezha
                                    ).toFixed(4)
                                  ).toFixed(2)}`
                                : ""}
                            </h5>}
                        </div>
                        <div className="col-4 sl-f-wargr">
                          <label>:ناوی وەرگر</label>
                          <select
                            disabled={
                              R_del_dis == true || this.props.savekrdn == true
                                ? true
                                : null
                            }
                            className={`form-control text-right font-weight-bold selectpicker pull-right ${
                              R_wargr == "ڕەهیل جاسم"
                                ? "bg-success text-white"
                                : `${
                                    R_wargr == "یاسین جاسم"
                                      ? "bg-danger text-white"
                                      : ""
                                  }`
                            }`}
                            onChange={AddProChange}
                            name="R_wargr"
                            value={R_wargr != null ? R_wargr : ""}
                          >
                            <option className="ml5">ناوی وەرگر</option>
                            <option>ڕەهیل جاسم</option>
                            <option>یاسین جاسم</option>
                          </select>
                        </div>
                        <div className="col-4 sl-f-jor">
                          <label>:جۆری دراو</label>
                          <select
                            className={`form-control text-right font-weight-bold selectpicker pull-right ${
                              R_joripara == "دۆلار"
                                ? "bg-success text-white"
                                : `${
                                    R_joripara == "دینار"
                                      ? "bg-danger text-white"
                                      : ""
                                  }`
                            }`}
                            onChange={AddProChange}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? R_anotherInputWakil(event)
                                : null
                            }
                            name="R_joripara"
                            value={R_joripara != null ? R_joripara : ""}
                          >
                            <option
                              className="ml5"
                              disabled={R_joripara != null ? true : null}
                            >
                              جۆری دراو
                            </option>
                            <option
                              disabled={R_joripara == "دینار" ? true : null}
                            >
                              دۆلار
                            </option>
                            <option
                              disabled={R_joripara == "دۆلار" ? true : null}
                            >
                              دینار
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-2 text-right sl-f-phone">
                        <div className="form-group">
                          <label>:تەلەفۆن</label>
                          <input
                            type="number"
                            value={R_mob}
                            disabled={
                              R_search_wakil == true ||
                              R_frosth == null ||
                              R_del_dis == true ||
                              this.props.savekrdn == true
                                ? true
                                : null
                            }
                            name="R_mob"
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? R_anotherInputWakil(event)
                                : null
                            }
                            onChange={AddProChange}
                            className={`form-control text-right font-weight-bold ${
                              R_frosth == "فرۆشتنی وەکیل"
                                ? "bg-success text-white"
                                : `${
                                    R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                      ? "bg-danger text-white"
                                      : ""
                                  }`
                            }`}
                          />
                        </div>
                      </div>
                      <div className="col-2 text-right sl-f-search">
                        <div className="form-group">
                          <label>:گەڕان</label>
                          <select
                            disabled={
                              R_del_dis == true || this.props.savekrdn == true
                                ? true
                                : null
                            }
                            className={`form-control  text-right font-weight-bold selectpicker pull-right ${
                              R_frosth == "فرۆشتنی وەکیل"
                                ? "bg-success text-white"
                                : `${
                                    R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                      ? "bg-danger text-white"
                                      : ""
                                  }`
                            }`}
                            onChange={WakilNameHandle}
                            name="R_nawe_barez"
                            value={R_nawe_barez}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? R_anotherInputWakil(event)
                                : null
                            }
                          >
                            <option className="ml5">گەڕان</option>
                            {wakilakan}
                          </select>
                        </div>
                      </div>
                      <div className="col-2 text-right sl-f-name">
                        <div className="form-group">
                          <label>:بەڕێز</label>
                          <input
                            type="text"
                            value={R_nawe_barez}
                            name="R_nawe_barez"
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? R_anotherInputWakil(event)
                                : null
                            }
                            disabled={
                              R_search_wakil == true ||
                              R_frosth == null ||
                              R_del_dis == true ||
                              this.props.savekrdn == true
                                ? true
                                : null
                            }
                            onChange={
                              R_frosth == "فرۆشتنی وەکیل" && R_zh_barez < 0
                                ? ""
                                : WakilNameHandle
                            }
                            className={`form-control text-right font-weight-bold ${
                              R_frosth == "فرۆشتنی وەکیل"
                                ? "bg-success text-white"
                                : `${
                                    R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                      ? "bg-danger text-white"
                                      : ""
                                  }`
                            }`}
                          />
                        </div>
                      </div>
                      <div className="col-3 text-right sl-flat">
                        <div className="row sl-flat">
                          <div className="col-4 sl-f-code">
                            <div className="form-group">
                              <label>:وەکیل</label>
                              <input
                                type="text"
                                value={R_zh_barez > 0 ? R_zh_barez : ""}
                                disabled={
                                  R_search_wakil == true ||
                                  R_frosth == "فرۆشتنی ڕاستەوخۆ" ||
                                  R_frosth == null ||
                                  R_del_dis == true ||
                                  this.props.savekrdn == true
                                    ? true
                                    : null
                                }
                                name="R_zh_barez"
                                onKeyPress={(event) =>
                                  event.key == "Enter"
                                    ? R_anotherInputWakil(event)
                                    : null
                                }
                                onChange={AddProChange}
                                className={`form-control text-right font-weight-bold  ${
                                  R_frosth == "فرۆشتنی وەکیل"
                                    ? "bg-success text-white"
                                    : `${
                                        R_frosth == "فرۆشتنی ڕاستەوخۆ" ? "" : ""
                                      }`
                                }`}
                              />
                            </div>
                          </div>
                          <div className="col-1 mr-3 sl-f-find">
                            <button
                              onClick={setSearchEmptyRentWakil}
                              disabled={
                                R_del_dis == true || this.props.savekrdn == true
                                  ? true
                                  : null
                              }
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? toanotherInput(event)
                                  : null
                              }
                              className="btn btn-dark mt4"
                            >
                              <i className="fas fa-search-plus"></i>
                            </button>
                          </div>
                          <div className="col-6 sl-f-type">
                            <select
                              disabled={
                                R_del_dis == true || this.props.savekrdn == true
                                  ? true
                                  : null
                              }
                              className={`form-control text-right font-weight-bold selectpicker pull-right mt4 ml3 ${
                                R_frosth == "فرۆشتنی وەکیل"
                                  ? "bg-success text-white"
                                  : `${
                                      R_frosth == "فرۆشتنی ڕاستەوخۆ"
                                        ? "bg-danger text-white"
                                        : ""
                                    }`
                              }`}
                              onChange={AddProChange}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? toanotherInput(event)
                                  : null
                              }
                              name="R_frosth"
                              value={R_frosth != null ? R_frosth : ""}
                            >
                              <option className="ml5">جۆری فرۆشتن</option>
                              <option> فرۆشتنی وەکیل</option>
                              <option> فرۆشتنی ڕاستەوخۆ</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className="row sl-meta">
                    <div className="col-3 sl-m-date">
                      <div className="row sl-m-daterow">
                        <div
                          className={`${R_togler ? "col-10" : "col-7"} pt2  tc`}
                        >
                          {R_togler == false ? (
                            <>
                              {R_search_wasl || R_save ? (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={R_wasl.date}
                                    format="YYYY-MM-DD"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              ) : (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={Date.now()}
                                    format="YYYY-MM-DD"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              )}
                            </>
                          ) : (
                            <input
                              type="datetime-local"
                              name="R_date"
                              value={R_date}
                              onChange={AddProChange}
                              className="form-control text-right font-weight-bold tc btn btn-info"
                            />
                          )}
                        </div>
                        {R_togler == true ? null : (
                          <div className="col-3">
                            <label className="text-warning font-weight-bold f4">
                              :بەروار{" "}
                            </label>
                          </div>
                        )}
                        <div className="col-2">
                          <button
                            onClick={inputtogler}
                            disabled={
                              R_del_dis == true || this.props.savekrdn == true
                                ? true
                                : null
                            }
                            className="btn btn-info"
                          >
                            <i className="far fa-calendar-alt white "></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 sl-m-time">
                      <div className="row">
                        <div className="col-6 pt2  tc">
                          {R_togler == true ? null : (
                            <>
                              {R_search_wasl == true ? (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={R_wasl.date}
                                    format="hh:mm:ss"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              ) : (
                                <p className="font-weight-bold bg-white">
                                  <Time
                                    value={Date.now()}
                                    format="hh:mm:ss"
                                    style={{ color: "black" }}
                                  />
                                </p>
                              )}
                            </>
                          )}
                        </div>
                        <div className="col-6">
                          <label className="text-warning font-weight-bold f4">
                            :کات{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 row sl-m-due">
                      <div className="col-7">
                        <input
                          type="date"
                          onChange={AddProChange}
                          name="R_kateQarz"
                          value={R_kateQarz}
                          className="selectpicker btn btn-warning f4"
                        />
                      </div>
                      <div className="col-5 row"></div>
                    </div>
                    <div className="col-2 sl-m-wasl">
                      <div className="row">
                        <div className="col-6">
                          <input
                            type="number"
                            onChange={AddProChange}
                            disabled={
                              R_open == true || R_table == true ? true : null
                            }
                            value={R_zh_wasl}
                            onKeyPress={(event) =>
                              event.key == "Enter"
                                ? getWaslDataBySearchRent(event)
                                : null
                            }
                            name="R_zh_wasl"
                            className="form-control text-right font-weight-bold px-0 bg-danger text-white"
                          />
                        </div>
                        <div className="col-6">
                          <label className="text-warning font-weight-bold f4">
                            :پسوولە{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 form-inline sl-m-next">
                      <h4 className="font-weight-bold  bg-success text-white ">
                        {R_zh_wasl_katy}
                      </h4>
                    </div>
                  </div>
                  <div className="row sl-modes">
                    <div className="col-3"></div>
                    <div className="col-1 sl-mo-stock">
                      {R_naweSht? <span
                          style={{
                            display: "block",
                            fontSize: "20px",
                            fontWeight: 600,
                            opacity: 0.8,
                        }}
                          className="text-warning"
                        >
                          {Number(_.sumBy(R_productBuy, (o) =>
                            Number(o.numberOfCarton)
                          )).toFixed(2)}
                          <hr style={{ margin: "0.1em 0", border: "1px solid #000" }} />
                          {Number(_.subtract(
                            Number(
                              _.sumBy(R_productBuy, (o) =>
                                Number(o.numberOfCarton)
                              )
                            ),
                            Number(R_rasidKarton)
                          )).toFixed(2)}
                        </span>:null}
                    </div>
                    <div className="col-5">
                      <div className="row sl-mo-switches">
                      
                        <div
                          className={`col-1 text-${
                            !R_Nrx_J_T_check ? "success" : "white"
                          }`}
                        >
                          دۆلار
                        </div>
                        <div className="col-2">
                          <label className="switch">
                            <input
                              type="checkbox"
                              id="toggle"
                              checked={R_Nrx_J_T_check}
                              onChange={OnChangeSwitch}
                              disabled={R_dataTable.length || R_joripara}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                        <div
                          className={`col-1 text-${
                            R_Nrx_J_T_check ? "success" : "white"
                          }`}
                        >
                          دۆلار٢
                        </div>
                        <div
                          className={`col-1 text-${
                            !R_Nrx_IQD_check ? "warning" : "white"
                          }`}
                        >
                          دینار
                        </div>
                        <div className="col-2">
                          <label className="switch">
                            <input
                              type="checkbox"
                              id="toggle"
                              checked={R_Nrx_IQD_check}
                              onChange={OnChangeSwitch_IQD}
                              disabled={R_dataTable.length || R_joripara}
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                        <div
                          className={`col-1 text-${
                            R_Nrx_IQD_check ? "warning" : "white"
                          }`}
                        >
                          دینار٢
                        </div>
                        
                      </div>
                    </div>
                    <div className="col-3"></div>
                  </div>
                </div>

                {R_search == true ? (
                  <div className="row text-warning font-weight-bold sl-chips">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-1">
                      <h4
                        className="border b--black"
                        style={{ backgroundColor: "#ff5507", color: "#fff" }}
                        name="zhmara"
                      >
                        {R_singleSale} IQD
                      </h4>
                    </div>
                    <div className="col-sm-1">
                      <h4
                        className="border b--black"
                        style={{
                          backgroundColor: "#17a2b8",
                          color: "#fff",
                          border: "2px solid #ffc107",
                          fontSize: "20px"
                        }}
                        name="dp"
                      >
                        P-| {R_dp || ""} |-D
                      </h4>
                    </div>
                    <div className="col-sm-1">
                     
                      <h5
                        className="border b--black text-center mb-0 py-1"
                        style={{
                          backgroundColor: "#32CD32",
                          color: "#000",
                          lineHeight: 1.15,
                        }}
                        name="rasid"
                        title="Rasid — carton balance"
                      >
                        <span style={{ fontSize: "18px", fontWeight: 700 }}>
                          R{" "}
                          {Number.isInteger(Number(R_rasidKarton))
                            ? Number(R_rasidKarton)
                            : Number(R_rasidKarton).toFixed(2)}
                        </span>
                        
                      </h5>
                    </div>

                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="kren"
                      >
                        K$ {Number(R_kren).toFixed(2)}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="nrxyakkarton"
                      >
                        KK$ {Number(R_nrxkaton).toFixed(2)}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="frosthndolar"
                      >
                        $ {R_nrx_dolar}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h5
                        className="border b--black bg-white text-dark"
                        name="frosthndolar"
                      >
                        2$ {R_Dolar2}
                      </h5>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="frosthndinar"
                      >
                        ID {R_nrx_dinarr}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="frosthndinar"
                      >
                        ID<sup style={{ color: "red" }}>2</sup> {R_nrx_dinarr2}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="niwkarton"
                      >
                        1/2ID {R_nrx_niwkarton}
                      </h6>
                    </div>
                    <div className="col-sm-1">
                      <h6
                        className="border b--black bg-white text-dark"
                        name="Rkmtrladadrzan"
                      >{`>10ID ${R_nrx_kmtrdadarzan}`}</h6>
                    </div>
                  </div>
                ) : null}
                <form>
                  <div
                    className="row text-warning font-weight-bold sl-item"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div className="col-1 text-right px-2 mt4 sl-i-btns">
                      <button
                        onClick={(e) => {
                          createNewPage(e);
                          this.props.onNewPage();
                        }}
                        disabled={
                          R_table == true || R_open == true ? true : null
                        }
                        className={`btn ${
                          R_open == true || R_table == true
                            ? "btn-danger"
                            : "btn-primary"
                        } mr2`}
                      >
                        <i className="far fa-file fa-lg"></i>
                      </button>
                      <button
                        onClick={(e) => saveDetail(e, R_wasl)}
                        className="btn btn-success"
                      >
                        <i className="far fa-save"></i>
                      </button>
                    </div>

                    <div className="col-2 text-right sl-i-total">
                      <div className="form-group ">
                        {R_joripara == "دۆلار" ? (
                          <>
                            <label>$ کۆی گشتی </label>
                            <input
                              type="number"
                              disabled={
                                R_del_dis == true || this.props.savekrdn == true
                                  ? true
                                  : null
                              }
                              value={
                                R_karton > 0 || R_darzan > 0
                                  ? R_getkoygahty(R_darzan, R_karton)
                                  : 0
                              }
                              onChange={AddProChange}
                              onKeyDown={R_CartonDarzanSfr}
                              // onKeyPress={(event) =>
                              //   event.key == "Enter"
                              //     ? saveDetail(event, R_wasl)
                              //     : null
                              // }
                              name="R_koygshty$"
                              className="form-control text-right font-weight-bold tc"
                            />
                          </>
                        ) : (
                          <>
                            <label>ID کۆی گشتی </label>
                            <input
                              type="number"
                              disabled={
                                R_del_dis == true || this.props.savekrdn == true
                                  ? true
                                  : null
                              }
                              value={
                                R_karton > 0 || R_darzan > 0
                                  ? R_getkoygahty(R_darzan, R_karton)
                                  : 0
                              }
                              onChange={AddProChange}
                              onKeyDown={R_CartonDarzanSfr}
                              // onKeyPress={(event) =>
                              //   event.key == "Enter"
                              //     ? saveDetail(event, R_wasl)
                              //     : null
                              // }
                              name="R_koygshtyID"
                              className="form-control text-right font-weight-bold tc"
                            />
                          </>
                        )}
                      </div>
                    </div>

                    <div className="col-1 text-right px-2 sl-i-rezha">
                      <div className="form-group">
                        <label>ڕێژە</label>
                        <input
                          type="number"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          value={R_rezha}
                          name="R_rezha"
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2 sl-i-nrx">
                      <div className="form-group">
                        <label>نرخ</label>
                        <input
                          type="text"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          value={R_nrx}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? NrxtofirstInputINRent(event)
                              : null
                          }
                          name="R_nrx"
                          onChange={R_nrxchange}
                          className="form-control text-right font-weight-bold pr-4"
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2 sl-i-darzan">
                      <div className="form-group">
                        <label>دەرزەن</label>
                        {/*  */}
                        <input
                          type="text"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          onClick={R_DarzanChange}
                          // onKeyPress={R_CartonDarzanSfr}
                          onChange={(e) => DarzanChange(e)}
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toKoyGshtiSave(event) : null
                          }
                          value={R_darzan}
                          name="R_darzan"
                          className="form-control text-right font-weight-bold pr-4"
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-1 text-right px-2 sl-i-karton">
                      <div className="form-group">
                        <label>کارتۆن</label>
                        <input
                          type="text"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? R_darzankartontoanotherInput(event)
                              : null
                          }
                          onChange={R_CartonChange}
                          value={R_karton}
                          name="R_karton"
                          className="form-control text-right font-weight-bold pr-4"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right sl-i-name">
                      <div className="form-group">
                        <label>ناوی شتەکان</label>
                        <input
                          type="text"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          value={R_naweSht}
                          name="R_naweSht"
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          className="form-control text-right font-weight-bold"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right px-2 sl-i-zh">
                      <div className="form-group">
                        <label>ژ.شتەکان</label>
                        <input
                          type="text"
                          disabled={
                            R_del_dis == true || this.props.savekrdn == true
                              ? true
                              : null
                          }
                          value={R_zhmarasht}
                          name="R_zhmarasht"
                          onKeyPress={(event) =>
                            event.key == "Enter" ? toanotherInput(event) : null
                          }
                          className="form-control text-right font-weight-bold"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right px-2 sl-i-code">
                      <div className="form-group">
                        <label>کۆد</label>
                        <input
                          type="text"
                          onClick={setSaletSearchEmty}
                          disabled={
                            R_del_dis === true || this.props.savekrdn === true
                              ? true
                              : null
                          }
                          onKeyPress={(event) =>
                            event.key === "Enter"
                              ? getProductDataBySearchRent(event)
                              : null
                          }
                          value={R_zhmara}
                          name="R_zhmara"
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold tc pr-4"
                          id="code_Sale"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right mt4 sl-i-find">
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">
                          <button
                            onClick={setSaletSearchEmty}
                            className="btn btn-dark"
                          >
                            <i className="fas fa-search-plus"></i>
                          </button>
                        </div>
                        <div className="col-3"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}

export default FillDetailRent;
